import _ from 'lodash';
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {GeneralService} from "../../../../services/generalService";
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit, ViewChild} from "@angular/core";
import {ClipboardService} from "ngx-clipboard";
import {Router} from "@angular/router";
import {DatePipe} from "@angular/common";
import {eachLimit} from 'async';
import {TrustifiTableComponent} from "../../../uiComponents/trustifi-table/trustifi-table.component";
import {Buffer} from 'safe-buffer';

@Component({
	selector: 'email-trace-component',
	templateUrl: './email-trace.component.html',
})

export class EmailTraceComponent implements OnInit {

	@ViewChild('emailTraceTableEl') emailTraceTableEl: TrustifiTableComponent;

	constructor(private router:Router,
				public gs: GeneralService,
				private rs: RouteService,
				private ns: NotificationService,
				private clipboard: ClipboardService) {
	}

	dic = DICTIONARY;
	isQueryError;

	showAbortLoadingEmailsLabel: boolean;
	abortLoadingFlag: any;

	logsScope = this.router.url.includes(this.dic.CONSTANTS.appStates.adminInbound) ? 'inbound' :
		this.router.url.includes(this.dic.CONSTANTS.appStates.adminOutbound) ? 'outbound' : null;

	filterEmailTraceData;
	logs;
	searchPeriods = [
		this.dic.CONSTANTS.trendsPeriod.lastDay,
		this.dic.CONSTANTS.trendsPeriod.last3Days,
		this.dic.CONSTANTS.trendsPeriod.lastWeek,
		this.dic.CONSTANTS.trendsPeriod.lastMonth,
		this.dic.CONSTANTS.trendsPeriod.range
	];
	statusQuery: any = [{display: 'Completed'}, {display: 'Quarantined'}, {display: 'In Process'}, {display: 'Failed'}];
	tracingQueryError;
	tracingQuery;
	tracingQueryDisplay;
	queryValidationErrors;
	showQueryModal;
	getEmailTracingInProcess;
	tracingData;
	_ = _;
	matchedOnRulesMap;
	activeMessageIdAsFilter;
	activeSenderAsFilter;
	activeRecipientAsFilter;
	activeSubjectAsFilter;
	queryTypes = {
		lastEmails: 'lastEmails',
		period: 'period',
	}
	queryType;
	previewEmailContentPopup;
	outboundEmailAnalysisPopup;
	previewAttachment;

	quarantinedEmailAction;
	quarantinedPlanInfo;

	ngOnInit() {
		// default query
		this.initTracingQuery();

		// CC: apply status filter passed from the home page Email Totals card - use only it, ignore last saved query
		if (window.history.state.data?.status?.length) {
			this.queryType = this.queryTypes.period;
			if (window.history.state.data.period) {
				this.tracingQuery.period = window.history.state.data.period;
			}
			this.tracingQuery.status = window.history.state.data.status;
			this.statusQuery.forEach(item => {
				item.selected = window.history.state.data.status.includes(item.display);
			});
			this.calculateQueryDisplay();
			this.getEmailTracing();
		}
		else {
			// last saved query (if there is any)
			this.restoreLastTracingQuery();
		}
		this.initEmailTraceFilters();

		if (!this.logsScope || this.logsScope === 'inbound') {
			this.rs.getQuarantinedPlanInfo().then((response) => {
				this.quarantinedPlanInfo = response;
			});
		}
	};

	ngOnDestroy(): void {
		this.abortLoadingFlag = true;
	}

	initTracingQuery = () => {
		this.queryType = this.queryTypes.lastEmails;
		this.tracingQueryError = '';

		this.tracingQuery = {
			period: this.dic.CONSTANTS.trendsPeriod.lastDay,
			range: {start: new Date(Date.now() - (1000 * 60 * 60 * 24)), end: new Date()},
			from: '',
			rcptTo: '',
			subject: '',
			message_id: '',
			status: ''
		};

		this.statusQuery.forEach(item => {
			item.selected = false;
		});

		this.tracingQueryDisplay = [{
			title: this.gs.toCapitalize(this.tracingQuery.period.display),
			tooltip: this.gs.toCapitalize(this.tracingQuery.period.display)
		}];
	}

	restoreLastTracingQuery = () => {
		// check previous query from localStorage and retrieve it
		let previousQuery;
		if (localStorage.emailTraceQuery) {
			try { // "try" in case the parameters won't parse correctly
				previousQuery = JSON.parse(localStorage.emailTraceQuery);
			}
			catch {}
		}
		if (previousQuery) {
			this.queryType = previousQuery.queryType || this.queryTypes.period;

			// remove unnecessary properties and assign query to UI
			previousQuery = _.pick(previousQuery, ['period', 'range', 'from', 'message_id', 'rcptTo', 'subject', 'status']);
			this.tracingQuery = previousQuery;
			if (this.tracingQuery.status?.length) {
				this.statusQuery.forEach(item => {
					if (previousQuery.status.includes(item.display)) {
						item.selected = true;
					}
				});
			}

			this.calculateQueryDisplay();
		}
	}

	initEmailTraceFilters = () => {
		this.filterEmailTraceData = {
			filterType: this.dic.CONSTANTS.tableFilters.emailTrace,
			filters: {
				status: ['Completed', 'Quarantined', 'In Process', 'Failed'],
			},
			initFiltersFunction: this.initEmailTraceFilters
		};

		if (!this.logsScope) {
			this.filterEmailTraceData.filters['direction'] = ['inbound', 'outbound'];
		}
	};

	resetQuery = () => {
		localStorage.removeItem('emailTraceQuery');
		this.initTracingQuery();
		this.calculateQueryDisplay();
	};

	calculateQueryDisplay = () => {
		this.tracingQueryDisplay = [];

		if (this.queryType === this.queryTypes.lastEmails) {
			this.tracingQueryDisplay.push({
				title: 'Last Emails',
				tooltip: 'Last Emails'
			});
		}
		else {
			_.mapValues<any>(this.tracingQuery,(value, queryKey) => {
				if (value) {
					switch (queryKey) {
						case 'message_id':
							queryKey = 'Message ID';
							break;

						case 'rcptTo':
							queryKey = 'Recipient';
							break;

						case 'period':
							queryKey = value.display;
							let periodTooltip = value.display;
							if (value.value === this.dic.CONSTANTS.trendsPeriod.range.value) {
								periodTooltip = 'From ' + (new DatePipe('en-US')).transform(this.tracingQuery.range.start as Date, 'MM/dd/yyyy HH:mm') + ' until ' + (new DatePipe('en-US')).transform(this.tracingQuery.range.end as Date, 'MM/dd/yyyy HH:mm');
							}
							value = periodTooltip;
							break;

						case 'range':
							return;

						case 'status':
							value = value.join(', ');
							break;
					}

					this.tracingQueryDisplay.push({title: queryKey, tooltip: value});
				}
			});
		}
	}

	applyQuery = () => {
		this.tracingQueryError = '';

		if (!this.validateQuery()) {
			return;
		}

		this.tracingQuery.status = this.statusQuery.filter(item => item.selected).map(item => item.display);

		this.showQueryModal = false;

		this.calculateQueryDisplay();

		this.getEmailTracing();
	}

	validateQuery = () => {

		this.queryValidationErrors = [];

		let isPassed = true;

		if (this.tracingQuery.period.value === this.dic.CONSTANTS.trendsPeriod.range.value) {
			const range:any = {
				start: (this.tracingQuery.range.start),
				end: (this.tracingQuery.range.end)
			};
			if (range.start > Date.now() || range.start > range.end) {
				this.ns.showWarnMessage(this.dic.ERRORS.adminQuarantinedDate);
				isPassed = false;
			}
		}

		return isPassed;
	}

	getQueryForLogs = () => {
		let queryData: any;

		if (this.queryType === this.queryTypes.lastEmails) {
			queryData = {
				period: this.dic.CONSTANTS.trendsPeriod.lastDay.value
			};
		}
		else {
			queryData = {
				period: this.tracingQuery.period.value,
			};

			if (this.tracingQuery.period?.value) {
				queryData.period = this.tracingQuery.period.value;
			}

			if (this.tracingQuery.message_id) {
				queryData.message_id = this.tracingQuery.message_id;
			}

			if (this.tracingQuery.from) {
				queryData.from = this.tracingQuery.from;
			}

			if (this.tracingQuery.rcptTo) {
				queryData.rcptTo = this.tracingQuery.rcptTo;
			}

			if (this.tracingQuery.subject) {
				queryData.subject = this.tracingQuery.subject;
			}

			if (this.tracingQuery.status) {
				queryData.status = this.tracingQuery.status;
			}

			if (this.tracingQuery.period.value === this.dic.CONSTANTS.trendsPeriod.range.value) {
				queryData.range = {start: this.tracingQuery.range.start, end: this.tracingQuery.range.end};
				if (queryData.range.start > Date.now() || queryData.range.start > queryData.range.end) {
					this.ns.showWarnMessage(this.dic.ERRORS.adminTrendsDate);
					return;
				}
				queryData.range.start = new Date(queryData.range.start).toISOString();
				queryData.range.end = new Date(queryData.range.end).toISOString();
			}
		}

		const paramsToLocalStorage = _.clone(this.tracingQuery);
		localStorage['emailTraceQuery'] = JSON.stringify(paramsToLocalStorage);

		return queryData;
	}

	getEmailTracing = () => {
		if (this.getEmailTracingInProcess) return;

		const queryData = this.getQueryForLogs();
		if (this.logsScope) {
			queryData.direction = this.logsScope;
		}

		this.getEmailTracingInProcess = true;
		this.showAbortLoadingEmailsLabel = true;
		this.abortLoadingFlag = false;

		this.tracingData = [];

		this.rs.getEmailTracingLog(queryData).then(data => {
			this.getEmailTracingInProcess = false;

			this.matchedOnRulesMap = {};

			this.tracingData = data?.logs.map(itm => {
				this.checkMatchedOnRuleMessage(itm);

				return { ...itm._source, _id: itm._id };
			}) || [];

			if (data.scrollId) {
				this.getEmailTracingLogBatch(queryData, data.scrollId);
			}
			else {
				this.alignMatchedOnRuleMessage();
				this.showAbortLoadingEmailsLabel = false;
			}
		}, err => {
			this.getEmailTracingInProcess = false;
		});
	};


	getEmailTracingLogBatch = (queryData, scrollId) => {
		if (this.abortLoadingFlag) {
			this.abortLoadingFlag = false;
			return;
		}

		queryData.scrollId = scrollId;
		this.rs.getEmailTracingLog(queryData).then(data => {
			this.getEmailTracingInProcess = false;

			this.tracingData = this.tracingData.concat(data?.logs.map(itm => {
				this.checkMatchedOnRuleMessage(itm);

				return { ...itm._source, _id: itm._id };
			}) || []);

			if (data.scrollId) {
				this.getEmailTracingLogBatch(queryData, data.scrollId);
			}
			else {
				this.alignMatchedOnRuleMessage();
				this.showAbortLoadingEmailsLabel = false;
			}
		}, err => {
			this.getEmailTracingInProcess = false;
		});
	};

	// in multiple-recipients email, the "matched on rule" message is shown only for the first recipient. this function align the rest of them with the data.
	alignMatchedOnRuleMessage = () => {
		if (this.logsScope !== 'outbound') {
			return;
		}

		this.tracingData.forEach(itm => {
			if (this.matchedOnRulesMap[itm.message_id] && !(itm.text && itm.text[1]?.log?.toLowerCase().startsWith('matched on rule'))) {
				itm.text.splice(1, 0, {...itm.text[0], log: this.matchedOnRulesMap[itm.message_id]});
			}
		});
	}

	checkMatchedOnRuleMessage = (itm) => {
		if (itm.direction !== 'outbound') {
			return;
		}

		if (itm._source?.text && itm._source.text[1]?.log?.toLowerCase().startsWith('matched on rule')) {
			this.matchedOnRulesMap[itm._source.message_id] = itm._source.text[1].log;
		}
	}


	showLogsAction = (emailObj) => {
		emailObj.isExpanded = !emailObj.isExpanded;
		if (emailObj.isExpanded && !emailObj.tracking && emailObj.direction === 'outbound') {
			emailObj.tracking = true;
			this.rs.getEmailEventsForRecipient(emailObj.rcptTo, emailObj.message_id).then((recipientObj) => {
				if (recipientObj?.track_events?.length) {
					recipientObj.track_events.forEach((trackingObj) => {
						if (trackingObj.note) {
							let addToNote = ''
							if (trackingObj.raw_data?.smtpResponse) {
								addToNote = ` (remote MTA IP: ${trackingObj.raw_data.remoteMtaIp} | smtp response: ${trackingObj.raw_data.smtpResponse})`;
							}
							if (trackingObj.raw_data?.complaintSubType) {
								addToNote = ` (${trackingObj.raw_data?.complaintSubType})`;
							}
							if (trackingObj.raw_data?.error) { // in case of send failed
								if (trackingObj.raw_data?.error.code) {
									addToNote = ` (${trackingObj.raw_data?.error.statusCode} ${trackingObj.raw_data?.error.code} ${trackingObj.raw_data?.error.message})`;
								}
								else {
									addToNote = ` (${trackingObj.raw_data?.error})`;
								}
							}

							const eventData:any = {
								timestamp: trackingObj.created,
								log: trackingObj.note + addToNote
							};
							if (trackingObj.name === 'Read' && trackingObj.location) {
								eventData.showMapIcon = true;
								eventData.ll = trackingObj.location.ll;
							}
							emailObj.text.push(eventData);
						}
					});

					if (recipientObj.canBlock) {
						emailObj.text.push({
							action: true,
							recipientObj
						});
					}

					// @ts-ignore
					emailObj.text.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
				}
			}, err => {
			});
		}
	}

	changeRecipientStatus(emailObj, recipientObj) {
		let actionButton = "";
		let title = "";
		let subtitle = "";
		let action;
		if (recipientObj.is_blocked) {
			title = "Unblock Recipient";
			subtitle = "Recipient will have access to this email";
			actionButton = this.gs.toCapitalize(this.dic.CONSTANTS.recipientStatus.unblock);
			action = this.dic.CONSTANTS.recipientStatus.unblock;
		}
		else {
			title = "Block Recipient";
			subtitle = "Recipient will not have access to this email";
			actionButton = this.gs.toCapitalize(this.dic.CONSTANTS.recipientStatus.block);
			action = this.dic.CONSTANTS.recipientStatus.block;
		}


		this.gs.showPopup({
			title: title,
			subTitle: subtitle,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: actionButton,
			doneCb: () => {
				this.rs.traceChangeRecipientStatus(recipientObj.user_id, recipientObj.email_id, recipientObj._id, {action: action}).then((response) => {
					recipientObj.is_blocked = !recipientObj.is_blocked;

					if (this.outboundEmailAnalysisPopup) {
						this.showOutboundAnalysis(emailObj); // refresh
					}
				});
			}
		});
	};

	openLocation = (ll) => {
		this.gs.openLocation(ll);
	};

	setMessageIdAsFilter = (tagName) => {
		this.activeMessageIdAsFilter = tagName;
		this.emailTraceTableEl.searchItem();
	};

	setSenderAsFilter = (sender) => {
		this.activeSenderAsFilter = sender;
		this.emailTraceTableEl.searchItem();
	};

	setRecipientAsFilter = (recipient) => {
		this.activeRecipientAsFilter = recipient;
		this.emailTraceTableEl.searchItem();
	};

	setSubjectAsFilter = (subject) => {
		this.activeSubjectAsFilter = subject;
		this.emailTraceTableEl.searchItem();
	};

	abortLoadingEmails = () => {
		this.abortLoadingFlag = true;
		this.getEmailTracingInProcess = false;
		this.showAbortLoadingEmailsLabel = false;
	}

	viewEmailContent = (recipientObj) => {
		this.previewEmailContentPopup = {
			emailContent: null,
			rawEmailContent: null,
			getEmailContentInProcess: true,
			error: '',
			show: true,
		};

		this.rs.getEmailTracingContent(recipientObj._id).then(response => {
			this.previewEmailContentPopup.emailContent = response?.parsedData || '';
			this.previewEmailContentPopup.rawEmailContent = response?.rawMail || '';
			if (this.previewEmailContentPopup.emailContent) {
				this.previewEmailContentPopup.processedHtml = this.processEmailContent(this.previewEmailContentPopup.emailContent);
			}
			this.previewEmailContentPopup.getEmailContentInProcess = false;
		}, err => {
			this.previewEmailContentPopup.getEmailContentInProcess = false;
			this.previewEmailContentPopup.error = err?.data?.message;
		});
	}

	downloadEml = (sourcePopupData) => {
		const attachment = {
			content: sourcePopupData.rawEmailContent,
			name: `${sourcePopupData.emailContent.subject}.eml`,
			contentType: 'message/rfc822'
		};
		this.gs.downloadData(attachment.content, attachment.name, attachment.contentType);
	}

	removeEmailFromRecipient = (recipients) => {
		this.gs.showPopup({
			title: `Remove email from ${recipients?.length > 1 ? `${recipients?.length} recipients` : recipients[0].rcptTo}`,
			subTitle: `Email will be removed from the selected recipients`,
			body: ['Note: To use this feature you need to be connected to the Exchange/Google API integration. This connection can be made from the Integrations page'],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: `Confirm`,
			doneCb: () => {
				eachLimit(recipients, 3, (recipientObj, callback) => {
					const actionInfo = {action: 'removeEmail', elkId: recipientObj._id};
					this.rs.emailTraceAction(actionInfo).then(data => {
						if (data.activity) {
							recipientObj.text.push({timestamp: new Date().toISOString(), log: data.activity});
						}
						this.ns.showInfoMessage('Email remove operation called successfully');
						callback();
					}, err => {
					});
				}, () => {});
			}
		});
	}

	resendEmailToRecipient = (recipients) => {
		this.gs.showPopup({
			title: `Resend email to ${recipients?.length > 1 ? `${recipients?.length} recipients` : recipients[0].rcptTo}`,
			subTitle: `Email will be resent to the selected recipients`,
			body: ['Note: If the email already exists in the recipient\'s mailbox, the newly resent email might not be delivered due to de-duplication by the recipient MTA.'],
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: `Confirm`,
			doneCb: () => {
				recipients.forEach((emailObj) => {
					const actionInfo = {action: 'resendEmail', elkId: emailObj._id};
					this.rs.emailTraceAction(actionInfo).then(data => {
						this.ns.showInfoMessage('Email resend operation called successfully');
					}, err => {
					});
				});
			}
		});
	}

	selectEmailBulkAction = (selectedItems, action) => {
		switch (action) {
			case 'Resend email':
				this.resendEmailToRecipient(selectedItems);
				break;

			case 'Remove email':
				this.removeEmailFromRecipient(selectedItems);
				break;
		}
	};

	showEmailBulkActions = () => {
		return ['Resend email', 'Remove email'];
	}

	selectEmailAction = (emailObj, action) => {
		switch (action) {
			case 'Resend email':
				this.resendEmailToRecipient([emailObj]);
				break;

			case 'Remove email':
				this.removeEmailFromRecipient([emailObj]);
				break;

			case 'View email':
				this.viewEmailContent(emailObj);
				break;

			case 'Threat Analysis':
				this.showThreatAnalysis(emailObj);
				break;

			case 'Outbound Analysis':
				this.showOutboundAnalysis(emailObj);
				break;
		}
	};

	showEmailActions = (emailObj) => {
		const actions = [];

		if (emailObj.direction === 'inbound') {
			if (emailObj.status === 'Quarantined' || emailObj.text?.find(itm => itm.log?.includes('(record saved)'))){
				actions.push('Threat Analysis');
			}
		}
		if (emailObj.direction === 'outbound') {
			actions.push('Outbound Analysis');
		}

		actions.push(...['View email', 'Resend email', 'Remove email']);
		return actions;
	}

	searchTraceLog = (searchTerm, activeFilters) => {
		this.tracingData.forEach(record => {
			// CC: filter by clicked cell values
			if (this.activeMessageIdAsFilter && record.message_id !== this.activeMessageIdAsFilter) {
				record.hide = true;
				return;
			}
			if (this.activeSenderAsFilter && record.from !== this.activeSenderAsFilter) {
				record.hide = true;
				return;
			}
			if (this.activeRecipientAsFilter && record.rcptTo !== this.activeRecipientAsFilter) {
				record.hide = true;
				return;
			}
			if (this.activeSubjectAsFilter && record.subject !== this.activeSubjectAsFilter) {
				record.hide = true;
				return;
			}

			// search
			if (searchTerm) {
				const isFound = searchTextExecute(record, searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			// filter
			if (activeFilters) {
				// need to match all filter types
				let numFilterToMatch = Object.keys(activeFilters).length;

				if (activeFilters.status?.length) {
					if (activeFilters.status.includes(record.status)) {
						numFilterToMatch--;
					}
				}

				if (activeFilters.direction?.length) {
					if (activeFilters.direction.includes(record.direction)) {
						numFilterToMatch--;
					}
				}

				if (numFilterToMatch) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	};

	exportEmailTraceCsv = (sortBy) => {
		if (!this.tracingData?.length) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}

		let csvString = "Date,Subject,Recipient,Sender,Message ID,Status,Logs\n";

		let sortedTable = _.reject(this.tracingData,'hide');
		if (sortBy) {
			sortedTable = this.gs.sortTable(sortedTable, sortBy);
		}

		sortedTable.forEach((emailTraceObj) => {
			const messages = [];
			emailTraceObj.text?.forEach((msgObj) => {
				messages.push(msgObj.log);
			});
			csvString += `${emailTraceObj.created},"${emailTraceObj.subject}",${emailTraceObj.rcptTo},${emailTraceObj.from},${emailTraceObj.message_id},${emailTraceObj.status},"${messages.join(' | ')}"\n`;
		});

		this.gs.exportCsv(csvString, `email_trace.csv`);
	}

	copyToClipboard = (textToCopy) => {
		this.clipboard.copy(textToCopy);
	}

	showThreatAnalysis = (emailObj) => {
		this.rs.getEmailTracingQuarantineInfo(emailObj._id).then(response => {
			this.quarantinedEmailAction = {
				action: this.dic.CONSTANTS.quarantinedActions.viewInfo.display,
				email: response,
			};
		});
	}

	showOutboundAnalysis = (emailObj) => {
		this.outboundEmailAnalysisPopup = {
			emailObj,
			trackingEvents: [],
			showHtml: false,
			emailContent: null,
			rawEmailContent: null,
			show: true,
			loading: true,

			getTrackingStatus: (eventName: string) => {
				const status = this.outboundEmailAnalysisPopup.recipientObj.events_status?.find(itm => itm.name === eventName)?.status;
				return status || 'none'; // Return 'none' if status is not found
			}
		};

		this.rs.getEmailEventsForRecipient(emailObj.rcptTo, emailObj.message_id).then((recipientObj) => {
			if (!recipientObj.viewContentPermission && recipientObj?.sensitivity?.sensitive_types?.length) {
				recipientObj.sensitivity.sensitive_types.forEach((sensitivityType) => {
					sensitivityType.content = '********************************';
				});
			}
			this.outboundEmailAnalysisPopup.recipientObj = recipientObj;
			this.outboundEmailAnalysisPopup.sensitivity = recipientObj?.sensitivity;

			const addEvent = (name, icon, label) => {
				this.outboundEmailAnalysisPopup.trackingEvents.push({ name, icon, label});
			}

			addEvent('Sent', 'far fa-envelope', 'Sent');

			if (recipientObj.methods?.postmark) {
				addEvent('Postmarked', 'far fa-stamp', 'Postmark');
			}

			addEvent('Delivery', 'far fa-check-circle', 'Delivered');

			const readEvent = recipientObj.track_events?.find(itm => itm.name === 'Read');
			addEvent('Opened', 'far fa-envelope-open', !readEvent && recipientObj.methods?.encrypt_content ? 'Opened' : 'Read');

			if (recipientObj.methods?.secure_reply) {
				addEvent('Reply Received', 'far fa-reply', 'Replied');
			}

			if (recipientObj.is_blocked) {
				addEvent('Blocked', 'far fa-ban', 'Blocked');
			}

			_.first(this.outboundEmailAnalysisPopup.trackingEvents)['isFirst'] = true;
			_.last(this.outboundEmailAnalysisPopup.trackingEvents)['isLast'] = true;


			this.outboundEmailAnalysisPopup.loading = false;
		}, () => {
			this.outboundEmailAnalysisPopup.loading = false;
		});
	}

	getOutboundEmailContent = () => {
		this.outboundEmailAnalysisPopup.getEmailContentInProcess = true;

		this.rs.getEmailTracingContent(this.outboundEmailAnalysisPopup.emailObj._id).then(response => {
			this.outboundEmailAnalysisPopup.emailContent = response?.parsedData || null;
			this.outboundEmailAnalysisPopup.rawEmailContent = response?.rawMail || '';

			if (this.outboundEmailAnalysisPopup.emailContent) {
				this.outboundEmailAnalysisPopup.processedHtml = this.processEmailContent(this.outboundEmailAnalysisPopup.emailContent);
			}
			this.outboundEmailAnalysisPopup.getEmailContentInProcess = false;
		}, () => {
			this.outboundEmailAnalysisPopup.getEmailContentInProcess = false;
		});
	}

	processEmailContent(contentData) {
		let html = `<div>`;

		if (contentData) {
			if (contentData.from && contentData.from.text) {
				contentData.from.text = contentData.from.text.replaceAll('<', '('); // problem to display <> in HTML
				contentData.from.text = contentData.from.text.replaceAll('>', ')');
				html += `<b>From:</b>  ${contentData.from.text}`;
			}

			if (contentData.to && contentData.to.text) {
				contentData.to.text = contentData.to.text.replaceAll('<', '('); // problem to display <> in HTML
				contentData.to.text = contentData.to.text.replaceAll('>', ')');
				html += `<br><b>To:</b>  ${contentData.to.text}`;
			}
			if (contentData.cc && contentData.cc.text) {
				contentData.cc.text = contentData.cc.text.replaceAll('<', '(');
				contentData.cc.text = contentData.cc.text.replaceAll('>', ')');
				html += `<br><b>Cc:</b>  ${contentData.cc.text}`;
			}

			html += `<br><b>Subject:</b>  ${contentData.subject}<br><hr><br></div>`;
			html += contentData.html || contentData.text || '';
		}

		return html;
	}

	downloadAttachment = (data, name, type) => {
		try {
			data = new Buffer(data, 'base64');
			this.gs.downloadData(data, name, type);
		} catch (err) {
			console.error(err);
		}
	};
}


function searchTextExecute(traceLog, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return ((traceLog.subject?.toLowerCase().indexOf(searchTerm) > -1) ||
		(traceLog.from?.toLowerCase().indexOf(searchTerm) > -1) ||
		(traceLog.rcptTo?.toLowerCase().indexOf(searchTerm) > -1) ||
		(traceLog.message_id?.toLowerCase().indexOf(searchTerm) > -1) ||
		(traceLog.lastDate && (new DatePipe('en-US')).transform(traceLog.lastDate || '', 'MM/dd/yyyy HH:mm').indexOf(searchTerm) > -1));
}
